import { ExternalLink, MonitorCog } from "lucide-react"
import { Card, CardContent } from "@/components/ui/card"

const WORKBENCHES = [
  { label: "Western Australia Workbench", url: "https://map-workbench.org/" },
  { label: "East Africa Workbench", url: "https://ea.map-workbench.org/" },
]

export default function PositWorkbenchPage() {
  return (
    <>
      <title>Posit Workbench - MAP Apps Platform</title>
      <div className="flex flex-1 items-center p-6">
      <div className="mx-auto w-full max-w-4xl space-y-8">
        <div className="space-y-2 text-center">
          <h1>Posit Workbench</h1>
          <p className="text-muted-foreground">Choose your MAP Posit Workbench instance.</p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2">
          {WORKBENCHES.map(({ label, url }) => (
            <a
              key={url}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="group no-underline! text-foreground! hover:text-foreground! focus-visible:outline-none"
              aria-label={`${label} (opens in a new tab)`}
            >
              <Card className="min-h-60 border shadow-sm transition-all group-hover:-translate-y-1 group-hover:border-primary group-hover:shadow-md group-focus-visible:ring-2 group-focus-visible:ring-ring">
                <CardContent className="relative flex flex-1 flex-col items-center justify-center gap-5 text-center">
                  <ExternalLink
                    aria-hidden="true"
                    className="absolute top-0 right-6 size-5 text-muted-foreground transition-colors group-hover:text-foreground"
                  />
                  <span className="flex size-20 items-center justify-center rounded-full bg-primary/20">
                    <MonitorCog aria-hidden="true" className="size-10" />
                  </span>
                  <span className="font-heading text-2xl font-semibold">{label}</span>
                </CardContent>
              </Card>
            </a>
          ))}
        </div>
      </div>
    </div>
    </>
  )
}
